import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box} from '@mui/material';


import Grid from '@mui/material/Grid';

import { fixUpperCaseandUnderscore } from '../../../Utils/Utils';

export default function DialogeConfirmationBox(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


  const mappedAddObject = () =>{
      if(props.hqCompanyObject !== null || props.hqCompanyObject !== undefined){

          return(
              Object.keys(props.hqCompanyObject).map((keyer, i) => {
  
                if(keyer==="branches" || keyer === "hq_id"){
                  return null;
                }else if(props.hqCompanyObject[keyer]===null){
                  return null;
                }else if(typeof(props.hqCompanyObject[keyer])==="object"){
                      return(
                          Object.keys(props.hqCompanyObject[keyer]).map((subKeyer,x)=>{
                              let newKey = fixUpperCaseandUnderscore(subKeyer);
                              if(subKeyer !=="address_id"){

                                return(
                                    <DialogContentText key={x}>
                                        {`${newKey} : ${props.hqCompanyObject[keyer][subKeyer]} `}
                                    </DialogContentText>
                                )
                              }else{
                                return null;
                              }
                          })
  
                      )
                  }else{
                      
                      let newKey = fixUpperCaseandUnderscore(keyer);
                      // keyer
                      return(
                          <DialogContentText key={i}>
                              {`${newKey} : ${props.hqCompanyObject[keyer]}`}
                              {/* <p >
                              {newKey}
                              <span style={{mr:"2vh"}}>{newKey}</span>
                              <span>{`: ${props.hqCompanyObject[keyer]}`}</span>
                              </p> */}
                          </DialogContentText>
                      )
                  }
              })
          );
      }
  };


  const updateTopLevelComponent = ()=>{
    return(
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box>
            <h6>From...</h6>
          </Box>
          {mappedUpdateObjectFrom()}
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box>
            <h6>To...</h6>
          </Box>
          {mappedUpdateObjectTo()}
        </Grid>
      </Grid>
    )
  };
  const mappedUpdateObjectFrom = () =>{
    if(props.intialUpdatedObject !== null || props.intialUpdatedObject !== undefined){

        return(
            Object.keys(props.intialUpdatedObject).map((keyer, i) => {

                if(keyer==="branches" || keyer === "hq_id"){
                  return null;
                }if(keyer=== "last_updated"){
                  return null;
                }else if(keyer === "hq_id"){
                  return null;
                }else if(typeof(props.intialUpdatedObject[keyer])==="object"){
                    return(
                        Object.keys(props.intialUpdatedObject[keyer]).map((subKeyer,x)=>{
                            let newKey = fixUpperCaseandUnderscore(subKeyer);
                            return(
                                <DialogContentText key={x}>
                                    {`${newKey} : ${props.intialUpdatedObject[keyer][subKeyer]} `}
                                    {/* <p>
                                    <span style={{mr:"2vh"}}>{`${newKey} `}</span>
                                    <span>{` : ${props.hqCompanyObject[keyer][subKeyer]}`}</span>
                                    </p> */}
                                </DialogContentText>
                            )
                        })

                    )
                }else{
                    
                    let newKey = fixUpperCaseandUnderscore(keyer);
                    // keyer
                    return(
                        <DialogContentText key={i}>
                            {`${newKey} : ${props.intialUpdatedObject[keyer]}`}
                        </DialogContentText>
                    )
                }
            })
        );
    }
  };
  const mappedUpdateObjectTo = () =>{
      if(props.updatedObject !== null || props.updatedObject !== undefined){

          return(
              Object.keys(props.updatedObject).map((keyer, i) => {

                  if(keyer ==="branches" || keyer === "hq_id"){
                    return null;
                  }else if(keyer === "last_updated"){
                    return null;
                  }else if(keyer === "hq_id"){
                    return null;
                  }else if(typeof(props.updatedObject[keyer])==="object"){
                      return(
                          Object.keys(props.updatedObject[keyer]).map((subKeyer,x)=>{
                              let newKey = fixUpperCaseandUnderscore(subKeyer);
                              return(
                                  <DialogContentText key={x}>
                                      {`${newKey} : ${props.updatedObject[keyer][subKeyer]} `}
                                      {/* <p>
                                      <span style={{mr:"2vh"}}>{`${newKey} `}</span>
                                      <span>{` : ${props.hqCompanyObject[keyer][subKeyer]}`}</span>
                                      </p> */}
                                  </DialogContentText>
                              )
                          })
  
                      )
                  }else{
                      
                      let newKey = fixUpperCaseandUnderscore(keyer);
                      // keyer
                      return(
                          <DialogContentText key={i}>
                              {`${newKey} : ${props.updatedObject[keyer]}`}
                          </DialogContentText>
                      )
                  }
              })
          );
      }
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        maxWidth={'md'}
        open={props.confirmationDialogeBoxOpen}
        onClose={props.handleConfirmDialogeBoxClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {`Do you want to proceed with ${props.titleAction} the ${props.addWhatCompanyType}?`}
        </DialogTitle>
        <DialogContent>
        {props.confirmationType === "Update" ? 
          updateTopLevelComponent()
            
            :
            mappedAddObject()
          }
            {/* {mappedAddObject()} */}
        </DialogContent>
        
        <DialogActions>
          <Button autoFocus onClick={(e)=>{props.dialogeConfirmationBoxAnswerHandle("Disagree")}}>
            Disagree
          </Button>
          <Button onClick={(e)=>{props.dialogeConfirmationBoxAnswerHandle("Agree")}} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}